import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import PlayerList from './pages/PlayerList';
import JoinUs from './pages/Join-us';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Vote from './pages/Vote';
import MonCompte from './pages/MonCompte';
import Wiki from './pages/Wiki';
import Games from './pages/Games';
import Shop from './pages/Shop';
import ProtectedRoute from './components/ProtectedRoute'; // Import ajouté
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'; 
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Navbar from './components/navbar';
import Footer from './components/Footer';
import JackpotBanner from './components/JackpotBanner';
import axios from 'axios';
import { normalizeTextPayload } from './utils/textEncoding';

axios.interceptors.response.use(
  (response) => {
    if (response && response.data !== undefined) {
      response.data = normalizeTextPayload(response.data);
    }
    return response;
  },
  (error) => {
    if (error?.response?.data !== undefined) {
      error.response.data = normalizeTextPayload(error.response.data);
    }
    return Promise.reject(error);
  }
);

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#B67A3C', // Bronze Nexus
      light: '#E4E7EC',
      dark: '#8D5A2A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#C9CED6', // Silver accent
      light: '#FFE55C',
      dark: '#B67A3C',
    },
    background: {
      default: '#0a0015',
      paper: '#1a0a2e',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Navbar />
        <JackpotBanner />
        <Routes>
          <Route path="/" element={<App />} /> 
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/players" element={<PlayerList />} /> 
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/vote" element={<Vote />} />
          <Route path="/account" element={<MonCompte />} />
          <Route path="/wiki" element={<Wiki />} />
          <Route path="/games" element={<Games />} />
          <Route path="/gateway/:key" element={<Navigate to="/login" replace />} />
          
          {/* Route protégée pour la boutique */}
          <Route element={<ProtectedRoute />}>
             <Route path="/shop" element={<Shop />} />
          </Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.log('Service Worker enregistré:', reg.scope),
      (err) => console.warn('Service Worker non enregistré:', err)
    );
  });
}